import { useTranslation } from "react-i18next";
import { useApiError } from "../../common/errors/useApiError";
import { useSub } from "../../common/subscription/useSub";
import { NeedsListView } from "./NeedsListView";

export const Behovsliste = () => {
  const { t } = useTranslation();
  const { canAssessNeeds } = useSub();
  const displayer = useApiError();
  if (!canAssessNeeds) return displayer.showNoAccess();
  return (
    <NeedsListView
      title={t("Needs overview")}
      description={t("All registered needs.")}
      mineOnly={false}
      urlStatusSync={true}
    />
  );
};
